var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c{fill:none;stroke:#208ce1;stroke-miterlimit:10;stroke-width:1.5px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(16033 -359)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-16033 359)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14686 -685.914)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1097.273,691.553v5.573h4.706",
    transform: "translate(261.422 -357.413)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 9.023,
    cy: 9.023,
    rx: 9.023,
    ry: 9.023,
    transform: "translate(1350 329.913)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.c78699dbc3ecc06d98e972f987c89244.svg";
export { ForwardRef as ReactComponent };